export enum UserRole {
    admin = 'admin',
    supplier = 'supplier',
}
